// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__1MnnK","header":"MergedInvoice_header__bm-Du"};